// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../parseISO/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var parseISO = convertToFP(fn, 1);
export default parseISO;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/parseISO/index.js
// module id = 961
// module chunks = 0